module.exports = __webpack_public_path__ + "img/AMD.319f9ac.svg";